import { selectFeatureFlags } from 'core/userContext';
import { useQueryContext } from 'modules/billing/contexts/QueryContext';
import { useMetricInfo } from 'modules/billing/hooks/useMetricInfo';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router';
import { AnalyticCard } from '../AnalyticCard';
import { AnalyticTable } from '../AnalyticTable';
import { AnalyticTileProps } from '../AnalyticTile';
import { ProjectBreakdownLink } from '../ProjectBreakdownLink';
import {
  JOURNEY_EVENTS_CARD_IDS,
  JOURNEY_EVENTS_CARD_TEXT,
  JOURNEY_EVENTS_METRIC_NAMES,
  JOURNEY_EVENTS_TABLE_COLUMNS,
} from './constants';
import { createJourneyTableMetrics } from './utils';

const { cardTitle, jvtCountDescription, jvtCountName, projectBreakdownUrl } =
  JOURNEY_EVENTS_CARD_TEXT;

export const JourneyEventsUsageCard = () => {
  const { search } = useLocation();
  const { JourneyExitEvents } = useSelector(selectFeatureFlags);
  const {
    isLoading,
    billingPeriodMetrics: { ByOrgProjectJourney = {} },
    projects,
  } = useQueryContext();
  const [jvtCountInfo] = useMetricInfo(JOURNEY_EVENTS_METRIC_NAMES);

  const metrics: AnalyticTileProps[] = [
    {
      limit: jvtCountInfo.annualLimit,
      metricDescription: jvtCountDescription,
      metricName: jvtCountName,
      metricValue: jvtCountInfo.value,
      timePeriod: jvtCountInfo.annualLimit ? 'per year' : jvtCountInfo.dateRangeText,
    },
  ];

  const tableMetrics = createJourneyTableMetrics(
    Object.values(ByOrgProjectJourney),
    projects,
    search,
  );

  return (
    <>
      {JourneyExitEvents && (
        <AnalyticCard
          CardAction={<ProjectBreakdownLink to={projectBreakdownUrl} />}
          data-test={JOURNEY_EVENTS_CARD_IDS.cardId}
          isLoading={isLoading}
          metrics={metrics}
          title={cardTitle}
        >
          <AnalyticTable
            gridLayout="1fr auto"
            columns={JOURNEY_EVENTS_TABLE_COLUMNS}
            metrics={tableMetrics}
          />
        </AnalyticCard>
      )}
    </>
  );
};
